import React from 'react'

import { billing } from '../../core/controllers/Billing';
import { cc } from '../../core/controllers/CreditCard';
import { modal } from '../../core/utilities/modal';
import { browserHistory } from 'react-router'

export default class AddCreditCardForm extends React.Component {
    constructor(props) {
        super(props);

        if(this.props.card) {
            let card = this.props.card
            this.state = {
                cardLabel: card.cardLabel,
                id: card.id,
                holderName: "",
                customBilling: false,
                address: null,
                city: null,
                state: null,
                zipcode: null,
                disableChangePrimary: false,
                isDefault: card.default
            }
        }
        else {
            this.state = {
                cardLabel: null,
                holderName: "",
                customBilling: false,
                address: null,
                city: null,
                state: null,
                zipcode: null,
            };
        }
    }

    componentDidMount() {
        var self = this;
        if (!this.props.card) {
            var stripe = Stripe(process.env.STRIPE_KEY);
            var elements = stripe.elements();
            // Element styles
            var style = {
                base: {
                    fontSize: "16px",
                    color: "#32325d",
                    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                    fontSmoothing: "antialiased", "::placeholder": {
                        color: "rgba(0,0,0,0.4)"
                    }
                }
            };

            var card = elements.create("card", { style: style });
            card.mount("#card-element");
            // Element focus ring
            card.on("focus", function() {
                var el = document.getElementById("card-element");
                el.classList.add("focused");
            });
            card.on("blur", function() {
                var el = document.getElementById("card-element");
                el.classList.remove("focused");
            });

            // Handle payment submission when user clicks the pay button.
            var button = document.getElementById("submit");
            button.addEventListener("click", function(event) {
                if (!self.validateData()) {return}
                event.preventDefault();
                changeLoadingState(true);

                try {
                    stripe
                        .createToken(card)
                        .then(function(token) {
                            if (token.error) {
                                modal.showInfo("Card details could not be verified, check that the card information is correct", "danger", "top", "center");
                                changeLoadingState(false);
                                return;
                            }

                            stripe
                                .createSource({
                                    type: token.token.type,
                                    owner: {
                                        name: self.state.holderName
                                    },
                                    token: token.token.id
                                })
                                .then(function(source) {
                                    changeLoadingState(false);
                                    if (source.error) {
                                        var displayError = document.getElementById("card-errors");
                                        displayError.textContent = result.error.message;
                                    } else {
                                        self.saveCreditCard(source);
                                    }
                                });
                        });
                } catch (error) {
                    modal.showInfo("Sorry, something went wrong", "danger", "top", "center");
                    changeLoadingState(false);
                }
            });

            // Show a spinner on payment submission
            var changeLoadingState = function(isLoading) {
                if (isLoading) {
                    document.querySelector("button").disabled = true;
                    jQuery('.requestLoader').addClass('loading').dequeue();
                } else {
                    document.querySelector("button").disabled = false;
                    jQuery('.requestLoader').clearQueue().removeClass('loading');
                }
            };
        }
    }

    toggleCustomBilling = () => {
        this.setState({
            customBilling: !this.state.customBilling
        })
    }

    toggleAuthorizePS= () => {
        this.setState({
            authorizePS: !this.state.authorizePS
        })
    }

    handleaddresschange = (e) => {
        this.setState({
            address: e.target.value
        })
    }

    handlecitychange = (e) => {
        this.setState({
            city: e.target.value
        })
    }

    handlestatechange = (e) => {
        this.setState({
            state: e.target.value
        })
    }

    handlezipcodechange = (e) => {
        this.setState({
            zipcode: e.target.value
        })
    }

    handleCardLabelChange = (e) => {
        this.setState({
            cardLabel: e.target.value
        });
    }

    handleNameHolderChange = (e) => {
        this.setState({
            holderName: e.target.value
        });
    }

    handleDefaultAccountChange = (e) => {
        this.setState({
            isDefault: e.target.value
        })
    }

    saveCreditCard = (source) => {
        var self = this;
        if(this.props.card) {
            if (!this.validateUpdateData()) {return;}

            modal.showDangerModalWithOK("Warning!","You are going to update this card.  Do you wish to continue?","Yes");
            jQuery(".move-on").on('click',function() {
                cc.updateCard(
                    {
                        isDefault: self.state.isDefault,
                        cardLabel: self.state.cardLabel,
                        id: self.state.id
                    },
                    function (response) {
                        if (response.status == 'OK') {
                            modal.showInfo("Your card has been successfully updated!", "success", "top", "center");
                            browserHistory.replace('/account/billing');
                        }
                    });
            });
        } else {
            cc.addCC(
                {
                    source: source,
                    label: this.state.label,
                    holderName: this.state.holderName,
                    cardLabel: this.state.cardLabel
                },
                function(response) {
                    if (response.status == 'OK') {
                        modal.showInfo("Your card has been successfully linked!", "success", "top", "center");
                        browserHistory.goBack();
                    }
                }
            );
        }
    }

    deleteCard = () => {
        var self = this;
        modal.showDangerModalWithOK("Warning!","You are going to remove this card.  Do you wish to continue?","Yes");
        jQuery(".move-on").on('click',function() {
            cc.deleteCard(self.state.id, function(response) {
                if (response.status == 'OK') {
                    modal.showInfo("Your card has been successfully removed!", "success", "top", "center");
                    browserHistory.replace('/account/billing');
                }
            });
        });
    }

    validateUpdateData() {
        const cardLabel = this.state.cardLabel

        if (cardLabel == null || cardLabel.length == 0) {
            modal.showInfo("Enter the credit card label!", "warning", "top", "center");
            return false;
        }

        return true;
    }

    validateData() {
        const cardLabel = this.state.cardLabel
        const customBilling = this.state.customBilling
        const address = this.state.address
        const city = this.state.city
        const state = this.state.state
        const zipcode = this.state.zipcode
        const authorizePS = this.state.authorizePS
        const holderName = this.state.holderName;

        if (cardLabel == null || cardLabel.length == 0) {
            modal.showInfo("Enter the credit card label!", "warning", "top", "center");
            return false;
        }

        if (holderName == null || holderName.length == 0) {
            modal.showInfo("Enter the card holders name!", "warning", "top", "center");
            return false;
        }

        if (customBilling) {
            if(address === null || address == "" || address.length == 0) {
                modal.showInfo("Specify the address.", "danger", "top", "center");
                return false;
            }

            if(city === null || city == "" || city.length == 0) {
                modal.showInfo("Specify the city.", "danger", "top", "center");
                return false;
            }

            if(state === null || state == "" || state.length == 0) {
                modal.showInfo("Specify the state.", "danger", "top", "center");
                return false;
            }

            if(zipcode === null || zipcode == "" || zipcode.length == 0) {
                modal.showInfo("Specify the zipcode.", "danger", "top", "center");
                return false;
            }
        }

        if (authorizePS === null || !(authorizePS === true)) {
            modal.showInfo("You must authorize Leasey.", "danger", "top", "center");
            return false;
        }
        return true;
    }

    render(){
        if (this.props.card) {
            const card = this.props.card;
            const cardLabel = this.state.cardLabel;
            const isDefault = this.state.isDefault;
            return (
                <div>
                <div class="row blue-bottom-margin">
                    <div class="col-md-12">
                        <div class="content">
                            <form>
                                <div class="sr-form-row row">
                                    <div class="col-md-5 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Card Label*</label>
                                            <input type="text" value={cardLabel} class="form-control tenant-info" placeholder="Chase Card" onChange={this.handleCardLabelChange}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-md-offset-1">
                                        <label>
                                            Card Information
                                        </label>
                                        <p>Last 4: <b>{card.last4}</b></p>
                                        <p>Expiration: <b>{card.exp_month}/{card.exp_year}</b></p>
                                        <p>Brand: <b>{card.brand}</b></p>
                                    </div>
                                </div>
                                <div class="sr-form-row row">
                                    <div class="col-md-5 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="phone">Is primary card?</label>
                                            <select class="form-control" disabled={this.state.disableChangePrimary} value={isDefault} onChange={this.handleDefaultAccountChange}>
                                                <option value="0">Select if primary card</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="row blue-bottom" style={{marginLeft:"-50px"}}>
                    <div class="blue-bottom-center-align">
                        <div class="col-md-4 col-md-offset-4">
                            <div class="row">
                                <button type="button" onClick={this.saveCreditCard} data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                    Update Card
                                </button>
                                <button type="button" onClick={this.deleteCard} data-loading-text="Loading..." class="btn btn-info btn-danger btn-fill col-md-offset-1" autoComplete="off">
                                    Delete Card
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )
        } else {
            const cardLabel = this.state.cardLabel
            const customBilling = this.state.customBilling
            const address = this.state.address
            const city = this.state.city
            const state = this.state.state
            const zipcode = this.state.zipcode
            const isDefault = this.state.isDefault
            const authorizePS = this.state.authorizePS
            const holderName = this.state.holderName;
            return (
                <div>
                    <div class="row blue-bottom-margin">
                        <p style={{textAlign: 'center'}}><small>Credit Card payments can take up to 5 - 7 business days to show up in your account.</small></p>
                        <div class="col-md-12">
                            <div class="content">
                                <form>
                                    <div class="sr-form-row row">
                                        <div class="col-md-5 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="phone">Card Label*</label>
                                                <input type="text" value={cardLabel} class="form-control tenant-info" placeholder="Chase Card" onChange={this.handleCardLabelChange}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sr-form-row row">
                                        <div class="col-md-5 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="phone">Name on Card*</label>
                                                <input type="text" value={holderName} class="form-control tenant-info" placeholder="John Doe" onChange={this.handleNameHolderChange}/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-12 col-xs-12 col-md-offset-1">
                                            <label>
                                                Card Information
                                            </label>
                                            <div
                                                class="disabled form-control tenant-info sr-input sr-element sr-card-element" 
                                                id="card-element"
                                                style={{paddingTop: "14px"}}
                                            />
                                        </div>
                                    </div>
                                    <div class="sr-form-row row">
                                        {/* <div class="col-md-5 col-sm-12 col-xs-12">
                                            <label>
                                                Payment details
                                            </label>
                                            <div class="sr-input sr-element sr-card-element" id="card-element">
                                            </div>
                                        </div> */}
                                        {/* <div class="col-md-12">
                                            <label class="filter-checkbox-container">Use different billing information from profile
                                                <input type="checkbox" class="filter-checkbox" checked={customBilling} onClick={this.toggleCustomBilling} />
                                            </label>
                                        </div>
                                        {customBilling && (
                                        <div>
                                            <div class="col-md-5 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <label for="address">Address*</label>
                                                    <input type="text" class="form-control" value={address} onChange={this.handleaddresschange} placeholder="10000 marshall dr." />
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-md-offset-1">
                                                <div class="form-group">
                                                    <label for="city">City*</label>
                                                    <input type="text" class="form-control" value={city} name="city" onChange={this.handlecitychange} placeholder="lenexa" />
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <UnitedStatesSelect columnSize={0} sortID={state} title="State*" onChange={this.handlestatechange}/>
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-md-offset-1">
                                                <div class="form-group">
                                                    <label for="address">Zipcode*</label>
                                                    <input type="text" class="form-control" value={zipcode} onChange={this.handlezipcodechange} placeholder="62472" />
                                                </div>
                                            </div>
                                        </div>
                                        )} */}
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 col-md-offset-2">
                                <div class="credit-card-confirm">
                                    <label class="filter-checkbox-container">
                                        <input type="checkbox" class="" checked={authorizePS} onClick={this.toggleAuthorizePS} />
                                        <span>    </span>
                                        <span>
                                            I authorize Leasey to send instructions to the financial institution that issued
                                            my card to take payments from my card account in accordance with the <a target="_blank" href="https://particlespace.com/terms-of-service/">
                                            terms of use
                                            </a>.
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row blue-bottom" style={{marginLeft:"-50px"}}>
                        <div class="blue-bottom-center-align">
                            <div class="col-md-4 col-md-offset-4">
                                <div class="row">
                                    <button type="button" id="submit" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                        <div class="spinner hidden" id="spinner"></div>
                                        <span id="button-text">
                                            Add Credit Card
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
};


// WEBPACK FOOTER //
// app/components/Billing/AddCreditCardForm.jsx